export default {
  PRIMARY: 'primary',
  SECONDARY: 'secondary',
  DARK: 'dark',
  LIGHT: 'light',
  LINK: 'link',
  OUTLINE: 'outline',
  DARK_BLOCK: 'dark block',
  LIGHT_BLOCK: 'light block',
  DARK_OUTLINE: 'dark outline',
  LIGHT_OUTLINE: 'light outline',
  DARK_LINK: 'dark link',
  LIGHT_LINK: 'light link'
}
